import { supabase } from "../lib/api";
import { LinkStatus } from "./addLink";

export const ITEMS_PER_PAGE = 11;

export const getAllPublishedLinks = async (
  tagId: number | null | undefined,
  page: number = 0
) => {
  const from = page > 0 ? page * ITEMS_PER_PAGE + 1 : page * ITEMS_PER_PAGE;
  const to = from + ITEMS_PER_PAGE;

  return tagId && tagId !== undefined
    ? await supabase
        .from("links")
        .select("*", { count: "exact" })
        .filter("status", "eq", LinkStatus.PUBLISHED)
        .filter("tag_id", "eq", tagId)
        .order("published_at", { ascending: false })
        .range(from, to)
    : await supabase
        .from("links")
        .select("*", { count: "exact" })
        .filter("status", "eq", LinkStatus.PUBLISHED)
        .order("published_at", { ascending: false })
        .range(from, to);
};
